import { ReactChild, ReactChildren } from 'react';

import { Box, Paper, PaperProps, Typography } from '@mui/material';

type TileProps = {
  children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[];
  title: string;
} & PaperProps;

const Tile = ({ title, children, ...rest }: TileProps) => {
  return (
    <Paper square {...rest}>
      <Box p={2}>
        <Typography variant="h2" mb={2}>
          {title}
        </Typography>
        {children}
      </Box>
    </Paper>
  );
};

export default Tile;
